import React from 'react';
import { Box } from '@mui/material';

import { images } from '../../../url/SvgLinks';
import { appInsights } from '../../../auth/appInsight';
import useBreakPoints from '../../../CustomHooks/useBreakPoints';

const FreedomSplash = images.FreedomSplash;

const FreedomGifLoader = () => {
  const {getAdjustedValues} = useBreakPoints()
  try {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)'
        }}
      >
        <img src={FreedomSplash} alt="Loading..." height={getAdjustedValues(200)} width={getAdjustedValues(200)} />
      </Box>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomGifLoader;
